import React from 'react';
import styled from 'styled-components';
import * as yup from 'yup';
import { Level, Label, Tab, Table } from 'rbx';
import { withFormik } from 'formik';
import { useStoreState } from 'easy-peasy';
import { isNull, isNaN } from 'lodash';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import { BsFillTelephoneFill } from 'react-icons/bs';
import { GoMail } from 'react-icons/go';
import { FaCalendar, FaClock } from 'react-icons/fa';
import { IoMdPeople } from 'react-icons/io';
import { MdBrunchDining, MdNotes } from 'react-icons/md';
import moment from 'moment-timezone';
import tzLookup from 'tz-lookup';

import uuidv4 from 'uuid/v4';

import Layout from '../../../components/global/Layout';
import {
  TextArea,
  Radio,
  CheckBox,
  ReactDateTimePicker,
  Select,
  Tabs,
} from '../../../components/elements';

import { useTableBookingsDetails } from '../TableBookingManager/helpers';
import Footer from './Footer';
import { useCreateTableBooking, useUpdateTableBooking } from './helpers';
import {
  useTableSetting,
  useTableSettingPrivate,
} from '../TableBookingSetting/helpers';
import PaymentsTab from './PaymentsTab';
import FormModal from './FormModal';

import ContextMenu from './ContextMenu';
import ContextMenuPopup from './ContextMenuPopup';
import { useAuditUserData } from '../TableBookingActivity/helpers';

const ActionButtonsContainer = styled.div`
  position: relative;
  left: 40px;
  width: 700px;
  display: flex;
  flex-direction: row;
  padding: 0 0 30px 0;
`;

const Gap = styled.div`
  margin: 0 1rem;
`;

const Wrapper = styled.div`
  padding: 1rem 1rem;
  border-bottom: 1px solid #f6f6f6;
`;

const Detail = styled.div`
  display: grid;
  grid-template-columns: 0.75fr 1.25fr;
  gap: 1rem;
  padding: 0 1rem;
  width: 100%;
  font-size: 16px;
  color: #505050;
`;

const Label2 = styled(Label)`
  font-size: 16px;
`;

const TwoByTwoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  padding: 0 1rem;
  width: 100%;
`;

const getTabs = bookingFee => {
  if (bookingFee) {
    return [
      {
        key: 'Booking',
        name: 'Booking',
        index: 0,
      },
      {
        key: 'Payments',
        name: 'Payments',
        index: 1,
      },
      { key: 'Refunds', name: 'Refunds', index: 2 },
      { key: 'Logs', name: 'Logs', index: 3 },
      { key: 'History', name: 'History', index: 4 },
      { key: 'Customer Profile', name: 'Customer Profile', index: 5 },
    ];
  }

  return [
    {
      key: 'Booking',
      name: 'Booking',
      index: 0,
    },
    { key: 'Refunds', name: 'Refunds', index: 2 },
    { key: 'Logs', name: 'Logs', index: 3 },
    { key: 'History', name: 'History', index: 4 },
    { key: 'Customer Profile', name: 'Customer Profile', index: 5 },
  ];
};

const Form = ({ ...props }) => {
  const {
    values,
    tableBookingDataProps,
    isSubmitting,
    handleSubmit,
    history,
    setFieldValue,
    errors,
    touched,
    updateTableBooking,
    updateTableBookingError,
    tableSettingProps,
    isAdd,
    validateForm,
    resetForm,
  } = props;

  const [activeTab, setActiveTab] = React.useState(0);

  const { userId: adminUserId } = useStoreState(state => state.auth);

  const { placeId, tableBookingId } = props;

  const [editIsActive, setEditIsActive] = React.useState(false);

  const [
    contextMenuPopupIsActive,
    setContextMenuPopupIsActive,
  ] = React.useState(false);

  // const settingsSmsValue =
  //   props?.tableSettingProps?.notification_setting?.sms_user_confirm_booking;

  // const minDate = React.useRef(values.booking_date);

  const onChangeBookingStatus = async bookingStatus =>
    updateTableBooking({
      user_id: adminUserId,
      table_booking_id: tableBookingDataProps.table_booking_id,
      booking_status: bookingStatus,
      is_sms_enabled: values.smsNotif,
      is_email_enabled: values.emailNotif,
    });

  const onChangeGuestStatus = async guestStatus =>
    updateTableBooking({
      user_id: adminUserId,
      table_booking_id: tableBookingDataProps.table_booking_id,
      guest_status: guestStatus,
      booking_status: 'MODIFIED',
      is_sms_enabled: values.smsNotif,
      is_email_enabled: values.emailNotif,
    });

  React.useEffect(() => {
    if (updateTableBookingError) {
      toast.error(updateTableBookingError);
    }
  }, [updateTableBookingError]);

  const collectBookingFee = !!tableBookingDataProps?.billing?.booking_total;

  const tabs = getTabs(collectBookingFee);

  const cancelledUser = useAuditUserData({
    userId: tableBookingDataProps?.cancelled?.created_by,
  });

  const contextMenuPopupProp = [
    {
      title: 'Refund Booking',
      can:
        values.paymentCaptured &&
        collectBookingFee &&
        values.booking_status !== 'RECEIVED',
      callback: () =>
        history.push(`/refund-booking/${placeId}/${tableBookingId}`),
    },
    {
      title: 'Cancel Booking',
      can: true,
      callback: () =>
        history.push(`/cancel-booking/${placeId}/${tableBookingId}`),
    },
    {
      title: 'Modify Booking',
      can: true,
      callback: () => setEditIsActive(true),
    },
  ];

  React.useEffect(() => {
    const timezone = tzLookup(
      tableBookingDataProps?.latitude,
      tableBookingDataProps?.longitude,
    );

    console.log('setting timezone =', timezone);

    moment.tz.setDefault(timezone);
  }, [tableBookingDataProps?.latitude, tableBookingDataProps?.longitude]);

  React.useEffect(() => {
    setFieldValue(
      'emailNotif',
      tableSettingProps.isEmailNotificationCheckboxEnabled,
    );
    setFieldValue(
      'smsNotif',
      tableSettingProps.isSMSNotificationCheckboxEnabled,
    );
  }, [
    tableSettingProps.isEmailNotificationCheckboxEnabled,
    tableSettingProps.isSMSNotificationCheckboxEnabled,
  ]);

  return (
    <Layout>
      {contextMenuPopupIsActive && (
        <ContextMenuPopup
          contextMenuPopupProp={contextMenuPopupProp}
          isActive={contextMenuPopupIsActive}
          onClose={() => setContextMenuPopupIsActive(false)}
        />
      )}
      <Wrapper>
        <Level>
          <Level.Item align="left">
            <div>
              <h1 className="mb-0 title is-size-4-touch is-size-3-desktop is-size-2-widescreen is-size-1-fullhd">
                Manage Booking
              </h1>
              <span>Manage your bookings and waitlists for a specific day</span>
            </div>
          </Level.Item>
          <Level.Item
            align="right"
            style={{ padding: 0, marginTop: 0, marginBottom: 0 }}
          >
            <Level.Item>
              <a onClick={() => history.goBack()} className="button is-grey">
                <span className="has-text-weight-semibold">Cancel</span>
              </a>
            </Level.Item>
            <Level.Item>
              <button
                type="submit"
                className={`button is-primary ${isSubmitting && 'is-loading'}`}
                onClick={handleSubmit}
              >
                <span>{isAdd ? 'Add Booking' : 'Update Booking'}</span>
              </button>
            </Level.Item>
          </Level.Item>
        </Level>
      </Wrapper>
      <div style={{ width: '64vw' }}>
        <div className="m-4">
          <h1 className="ml-4 mb-0 title is-2 is-flex is-justify-content-space-between">
            {values.first_name} {values.last_name}
            <div
              style={{
                width: '150px',
              }}
            >
              <Select
                options={[]}
                value={[
                  {
                    label: values.booking_status,
                    value: values.booking_status,
                  },
                ]}
                disableToastMessage
                disabled
              />
            </div>
          </h1>
          <div>
            <div className="is-flex is-justify-content-space-between ml-4 mr-4">
              <div className="is-flex is-justify-content-space-evenly is-align-items-center">
                <p className="is-flex is-justify-content-space-evenly is-align-items-center">
                  <BsFillTelephoneFill />
                  <p className="ml-2">{values.contact_phone}</p>
                </p>
                <p className="ml-2 is-flex is-justify-content-space-evenly is-align-items-center">
                  <GoMail />
                  <p className="ml-2">{values.contact_email}</p>
                </p>
              </div>
              <div>
                <div className="is-flex">
                  <div className="is-flex is-justify-content-space-center is-align-items-center">
                    <Label className="pr-4 mt-1">Email Notification</Label>
                    <CheckBox
                      value={values.emailNotif}
                      onChange={e => {
                        setFieldValue('emailNotif', e);
                      }}
                    />
                  </div>
                  <div className="is-flex is-justify-content-space-center is-align-items-center">
                    <Label className="pr-4 mt-1">SMS Notification</Label>
                    <CheckBox
                      value={values.smsNotif}
                      onChange={e => {
                        setFieldValue('smsNotif', e);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="m-4">
        <Table style={{ width: '75%' }}>
          <thead style={{ backgroundColor: '#d0d0d0' }}>
            <tr>
              <th style={{ border: '1px solid black', fontWeight: 700 }}>
                <div>
                  <span>ALL VISITS 69</span>
                </div>
              </th>
              <th style={{ border: '1px solid black', fontWeight: 700 }}>
                <div>
                  <span>RESERVATIONS 1</span>
                </div>
              </th>
              <th style={{ border: '1px solid black', fontWeight: 700 }}>
                <div>
                  <span>MATERIALISED 10</span>
                </div>
              </th>
              <th style={{ border: '1px solid black', fontWeight: 700 }}>
                <div>
                  <span>SPEND $100.00</span>
                </div>
              </th>
            </tr>
            <tr>
              <th style={{ border: '1px solid black', fontWeight: 700 }}>
                <div>
                  <span>UPCOMING 2</span>
                </div>
              </th>
              <th style={{ border: '1px solid black', fontWeight: 700 }}>
                <div>
                  <span>WALK - INS 3</span>
                </div>
              </th>

              <th style={{ border: '1px solid black', fontWeight: 700 }}>
                <div>
                  <span>CANCELLATIONS 4</span>
                </div>
              </th>
              <th style={{ border: '1px solid black', fontWeight: 700 }}>
                <div>
                  <span>NO SHOWS 69</span>
                </div>
              </th>
            </tr>
          </thead>
        </Table>
      </div>
      <Tabs className="tabs is-medium">
        {tabs.map(tab => (
          <Tab
            active={activeTab === tab.index}
            key={tab.key}
            onClick={() => setActiveTab(tab.index)}
            style={{ minWidth: '180px' }}
          >
            {tab.name}
          </Tab>
        ))}
        <ContextMenu onClick={() => setContextMenuPopupIsActive(true)} />
      </Tabs>

      {activeTab === 0 && (
        <>
          {tableBookingDataProps?.cancelled?.created_by && (
            <div className="m-4 columns">
              <fieldset className="p-4 column is-three-quarters box">
                <TwoByTwoGrid>
                  <Detail>
                    <h2 className="title is-2">Cancellation Details</h2>
                  </Detail>
                  <Detail />
                  <Detail>
                    <p>Cancelled By:</p>
                    <Label2>
                      {cancelledUser?.display_name} {cancelledUser?.email}
                    </Label2>
                  </Detail>
                  <Detail>
                    <p>User Type:</p>
                    <Label2>
                      {tableBookingDataProps?.cancelled?.user_type}
                    </Label2>
                  </Detail>
                  <Detail>
                    <p>Date:</p>
                    <Label2>
                      {moment(
                        tableBookingDataProps?.cancelled?.created_at,
                      ).format('DD/MM/YYYY')}{' '}
                      at&nbsp;
                      {moment(
                        tableBookingDataProps?.cancelled?.created_at,
                      ).format('hh:mm A')}
                    </Label2>
                  </Detail>
                  <Detail>
                    <p>Reason:</p>
                    <Label2>{tableBookingDataProps?.cancelled?.reason}</Label2>
                  </Detail>
                  <Detail>
                    <p>Note:</p>
                    <Label2>{tableBookingDataProps?.cancelled?.note}</Label2>
                  </Detail>
                </TwoByTwoGrid>
              </fieldset>
            </div>
          )}

          <div className="m-4 columns">
            <fieldset className="p-4 column is-three-quarters box">
              <div
                style={{
                  float: 'right',
                }}
              >
                <button
                  onClick={() => {
                    setEditIsActive(true);
                  }}
                  type="button"
                  className="button is-outlined is-grey"
                >
                  EDIT
                </button>
              </div>
              <TwoByTwoGrid>
                <Detail>
                  <p>Booking Ref:</p>
                  <Label2>{tableBookingDataProps.booking_reference}</Label2>
                </Detail>
                <Detail />
                <Detail>
                  <p>Booked on:</p>
                  <ReactDateTimePicker
                    value={
                      new Date(tableBookingDataProps?.received?.created_at)
                    }
                    disabled
                  />
                </Detail>
                <Detail />
                <Detail>
                  <p>Channel:</p>
                  <Label2>Online</Label2>
                </Detail>
                <Detail>
                  <p>Booking Name:</p>
                  <Label2>
                    {values.first_name} {values.last_name}
                  </Label2>
                </Detail>
                <Detail>
                  <p>Phone:</p>
                  <Label2>{values.contact_phone}</Label2>
                </Detail>
                <Detail>
                  <p>Email:</p>
                  <Label2>{values.contact_email}</Label2>
                </Detail>
                <Detail>
                  <p>Tags:</p>
                  <Label2>{(values.tags ?? []).join(', ')}</Label2>
                </Detail>
                <Detail>
                  <p>Special Requests:</p>
                  <Label2>{values.guest_notes}</Label2>
                </Detail>
              </TwoByTwoGrid>
            </fieldset>
          </div>
          {!isAdd && (
            <ActionButtonsContainer>
              {values.paymentCaptured && collectBookingFee && (
                <>
                  <button
                    className="button is-grey is-outlined"
                    onClick={() => {
                      if (values.booking_status === 'RECEIVED') {
                        swal({
                          text: 'Please confirm the table booking',
                        });
                      } else {
                        swal({
                          text: 'Would you like to refund this table booking?',
                          buttons: ['Cancel', 'OK'],
                        }).then(res => {
                          if (res) {
                            history.push(
                              `/refund-booking/${placeId}/${tableBookingId}`,
                            );
                          }
                        });
                      }
                    }}
                  >
                    Refund Booking
                  </button>
                  <Gap />
                </>
              )}
              <button
                className="button is-grey is-outlined"
                disabled={values.booking_status === 'CANCELLED'}
                onClick={() => {
                  swal({
                    text: 'Would you like to cancel this table booking?',
                    buttons: ['Cancel', 'OK'],
                  }).then(res => {
                    if (res) {
                      history.push(
                        `/cancel-booking/${placeId}/${tableBookingId}`,
                      );
                    }
                  });
                }}
              >
                Cancel Booking
              </button>
              <Gap />
              <button
                className="button is-warning is-outlined"
                disabled={
                  values.booking_status === 'WAITLISTED' ||
                  values.booking_status === 'CANCELLED'
                }
                onClick={() => {
                  if (values.booking_status === 'WAITLISTED') {
                    // pass
                  } else {
                    swal({
                      text: 'Would you like to waitlist this table booking?',
                      buttons: ['Cancel', 'OK'],
                    }).then(res => {
                      if (res) {
                        onChangeBookingStatus('WAITLISTED');
                        console.log('Waitlisting...');
                      }
                    });
                  }
                }}
              >
                Waitlist Booking
              </button>
              <Gap />
              {values.booking_status === 'CONFIRMED' && (
                <>
                  <button
                    onClick={() => {
                      if (values.booking_status === 'CONFIRMED') {
                        // pass
                      } else {
                        swal({
                          text: 'Would you like to confirm this table booking?',
                          buttons: ['Cancel', 'OK'],
                        }).then(res => {
                          if (res) {
                            onChangeBookingStatus('CONFIRMED');
                            console.log('confirming...');
                          }
                        });
                      }
                    }}
                    className="button is-outlined is-primary"
                  >
                    Resend Confirmation
                  </button>
                  <Gap />
                </>
              )}
              {values.booking_status !== 'CONFIRMED' && (
                <>
                  <button
                    className="button is-primary is-outlined"
                    disabled={
                      values.booking_status === 'CONFIRMED' ||
                      values.booking_status === 'CANCELLED'
                    }
                    onClick={() => {
                      if (values.booking_status === 'CONFIRMED') {
                        // pass
                      } else {
                        swal({
                          text: 'Would you like to confirm this table booking?',
                          buttons: ['Cancel', 'OK'],
                        }).then(res => {
                          if (res) {
                            onChangeBookingStatus('CONFIRMED');
                            console.log('confirming...');
                          }
                        });
                      }
                    }}
                  >
                    Confirm Booking
                  </button>
                  <Gap />
                </>
              )}
            </ActionButtonsContainer>
          )}
          <div className="is-flex" style={{ padding: '10px' }}>
            <div style={{ padding: '0 20px' }}>
              <div
                style={{ padding: '10px', position: 'relative', top: '-8px' }}
              >
                <Label>Guest Status</Label>
              </div>
            </div>
            <div style={{ padding: '0 25px' }}>
              <div className="is-flex">
                <Level.Item>
                  <div style={{ padding: '0 20px', fontWeight: '800' }}>
                    <Radio
                      stopClickFn
                      label="UPCOMING"
                      value={values.guest_status === 'UPCOMING'}
                      onChange={() => {
                        if (isAdd) {
                          setFieldValue('guest_status', 'UPCOMING');
                        } else {
                          swal({
                            text:
                              'Would you like to UPCOMING this table booking?',
                            buttons: ['Cancel', 'OK'],
                          }).then(res => {
                            if (res) {
                              onChangeGuestStatus('UPCOMING');
                              console.log('UPCOMING...');
                            }
                          });
                        }
                      }}
                    />
                  </div>
                </Level.Item>
                &nbsp;
                <Level.Item>
                  <div style={{ padding: '0 20px', fontWeight: '800' }}>
                    <Radio
                      stopClickFn
                      label="CHECKED IN"
                      value={values.guest_status === 'CHECKEDIN'}
                      onChange={() => {
                        if (isAdd) {
                          swal({
                            text:
                              'Would you like to CHECKED IN this table booking?',
                            buttons: ['Cancel', 'OK'],
                          }).then(res => {
                            if (res) {
                              setFieldValue('guest_status', 'CHECKEDIN');
                            }
                          });
                        } else {
                          swal({
                            text:
                              'Would you like to CHECKED IN this table booking?',
                            buttons: ['Cancel', 'OK'],
                          }).then(res => {
                            if (res) {
                              onChangeGuestStatus('CHECKEDIN');

                              console.log('CHECKEDIN...');
                            }
                          });
                        }
                      }}
                    />
                  </div>
                </Level.Item>
                &nbsp;
                <Level.Item>
                  <div style={{ padding: '0 20px', fontWeight: '800' }}>
                    <Radio
                      stopClickFn
                      label="SEATED"
                      value={values.guest_status === 'SEATED'}
                      onChange={() => {
                        if (isAdd) {
                          swal({
                            text:
                              'Would you like to SEATED this table booking?',
                            buttons: ['Cancel', 'OK'],
                          }).then(res => {
                            if (res) {
                              setFieldValue('guest_status', 'SEATED');
                            }
                          });
                        } else {
                          swal({
                            text:
                              'Would you like to SEATED this table booking?',
                            buttons: ['Cancel', 'OK'],
                          }).then(res => {
                            if (res) {
                              onChangeGuestStatus('SEATED');
                              console.log('SEATED...');
                            }
                          });
                        }
                      }}
                    />
                  </div>
                </Level.Item>
                &nbsp;
                <Level.Item>
                  <div style={{ padding: '0 20px', fontWeight: '800' }}>
                    <Radio
                      stopClickFn
                      label="NO SHOW"
                      value={values.guest_status === 'NO SHOW'}
                      onChange={() => {
                        if (isAdd) {
                          swal({
                            text:
                              'Would you like to NO SHOW this table booking?',
                            buttons: ['Cancel', 'OK'],
                          }).then(res => {
                            if (res) {
                              setFieldValue('guest_status', 'NO SHOW');
                            }
                          });
                        } else {
                          swal({
                            text:
                              'Would you like to NO SHOW this table booking?',
                            buttons: ['Cancel', 'OK'],
                          }).then(res => {
                            if (res) {
                              onChangeGuestStatus('NO SHOW');
                              console.log('NOSHOW...');
                            }
                          });
                        }
                      }}
                    />
                  </div>
                </Level.Item>
                &nbsp;
              </div>
            </div>
          </div>
          <div className="m-4 columns">
            <fieldset className="p-4 column is-three-quarters box">
              <div style={{ float: 'right' }}>
                <button
                  type="button"
                  onClick={() => {
                    setEditIsActive(true);
                  }}
                  className="button is-outlined is-grey"
                >
                  EDIT
                </button>
              </div>
              <TwoByTwoGrid>
                <Detail>
                  <h2 className="title is-2">Booking Details</h2>
                </Detail>

                {tableBookingDataProps?.billing?.sub_total ? (
                  <Detail>
                    <h2 className="title is-2">Payments</h2>
                  </Detail>
                ) : (
                  <Detail />
                )}

                <Detail>
                  <p className="is-flex is-justify-content-space-left is-align-items-center">
                    <FaCalendar />
                    <span className="pl-2">Booking Date:</span>
                  </p>
                  <ReactDateTimePicker
                    value={new Date(values.booking_date)}
                    onChange={value => {
                      setFieldValue('booking_date', value);
                    }}
                    disabled
                    minDate={new Date()}
                  />
                </Detail>

                {collectBookingFee ? (
                  <Detail>
                    <p>Deposit</p>
                    <Label2>
                      {tableBookingDataProps?.guest_count &&
                      tableSettingProps?.booking_fee?.booking_fee_info
                        ?.booking_deposit &&
                      tableSettingProps?.booking_fee?.booking_fee_info
                        ?.booking_type === 'FEE_PER_GUEST'
                        ? `$${parseFloat(
                            tableSettingProps?.booking_fee?.booking_fee_info
                              ?.booking_deposit,
                          )} x ${tableBookingDataProps?.guest_count}`
                        : ''}
                      &nbsp; $
                      {parseFloat(
                        tableBookingDataProps?.billing?.sub_total,
                      ).toFixed(2)}
                    </Label2>
                  </Detail>
                ) : (
                  <Detail />
                )}
                <Detail>
                  <p className="is-flex is-justify-content-space-left is-align-items-center">
                    <FaClock />
                    <span className="pl-2">Booking Time:</span>
                  </p>
                  <Label2>{values.booking_time}</Label2>
                </Detail>
                {collectBookingFee ? (
                  <Detail>
                    <p>Booking Total</p>
                    <Label2>
                      $
                      {parseFloat(
                        tableBookingDataProps?.billing?.booking_total,
                      ).toFixed(2)}
                    </Label2>
                  </Detail>
                ) : (
                  <Detail />
                )}
                <Detail>
                  <p className="is-flex is-justify-content-space-left is-align-items-center">
                    <IoMdPeople />
                    <span className="pl-2">No of Guests:</span>
                  </p>
                  <Label2>{values.guest_count}</Label2>
                </Detail>
                {collectBookingFee ? (
                  <p>
                    {tableBookingDataProps?.payment?.payment_at &&
                      tableBookingDataProps?.payment?.payment_card?.brand &&
                      tableBookingDataProps?.payment?.payment_card?.last4 && (
                        <Detail>
                          <p className="is-size-4 has-text-weight-semibold">
                            Paid: $
                            {parseFloat(
                              tableBookingDataProps?.billing?.booking_total,
                            ).toFixed(2)}{' '}
                            on{' '}
                            {moment(
                              tableBookingDataProps?.payment?.payment_at,
                            ).format('ddd, MMM DD, YYYY hh:mm A')}
                          </p>
                          <p>
                            {
                              tableBookingDataProps?.payment?.payment_card
                                ?.brand
                            }{' '}
                            ending in{' '}
                            {
                              tableBookingDataProps?.payment?.payment_card
                                ?.last4
                            }
                          </p>
                        </Detail>
                      )}
                  </p>
                ) : (
                  <Detail />
                )}
                <Detail>
                  <p className="is-flex is-justify-content-space-left is-align-items-center">
                    <MdBrunchDining />
                    <span className="pl-2">Table Number:</span>
                  </p>
                  <Label2>{values.table_number}</Label2>
                </Detail>
                <Detail />
                <Detail>
                  <p className="is-flex is-justify-content-space-left is-align-items-center">
                    <MdNotes />
                    <span className="pl-2">Guest Notes:</span>
                  </p>
                  <Label2>{values.guest_notes}</Label2>
                </Detail>
              </TwoByTwoGrid>
            </fieldset>
          </div>
          <div className="m-4 columns">
            <div className="p-4 column is-three-quarters ">
              <Label>Restaurant Notes</Label>
              <TextArea
                value={values.restaurant_notes}
                onChange={e =>
                  setFieldValue('restaurant_notes', e.target.value)
                }
                name="Restaurant Requests"
                errors={errors.restaurant_notes}
                touched={touched.restaurant_notes}
                optionalText="(Max 144 Characters)"
              />
              {values.restaurant_notes && (
                <div style={{ textAlign: 'right' }}>
                  {values.restaurant_notes.length > 144 ||
                  values.restaurant_notes.length < 1
                    ? ''
                    : `Characters left ${144 - values.restaurant_notes.length}`}
                </div>
              )}
            </div>
          </div>
        </>
      )}
      {activeTab === 1 && (
        <PaymentsTab
          tableBookingDataProps={tableBookingDataProps}
          tableSettingProps={tableSettingProps}
          refundSummary={values.refundSummary}
        />
      )}
      {activeTab === 2 && (
        <div className="m-4 has-text-danger">Not Yet Implemented!</div>
      )}
      {activeTab === 3 && (
        <div className="m-4 has-text-danger">Not Yet Implemented!</div>
      )}
      {activeTab === 4 && (
        <div className="m-4 has-text-danger">Not Yet Implemented!</div>
      )}
      {activeTab === 5 && (
        <div className="m-4 has-text-danger">Not Yet Implemented!</div>
      )}
      {editIsActive && (
        <FormModal
          {...props}
          isActive={editIsActive}
          onSubmit={async () => {
            const calculatedErrors = await validateForm();
            const temp = Object.values(calculatedErrors);
            if (Array.isArray(temp) && temp[0]) {
              try {
                handleSubmit();
              } catch {
                // pass
              }

              swal({
                title: 'Error',
                text: temp[0],
                icon: 'warning',
                dangerMode: true,
              });
            } else {
              setEditIsActive(false);
            }
          }}
          onClose={async () => {
            const calculatedErrors = await validateForm();
            const temp = Object.values(calculatedErrors);
            if (Array.isArray(temp) && temp[0]) {
              try {
                resetForm();
              } catch {
                // pass
              }
            } else {
              // pass
            }

            setEditIsActive(false);
          }}
        />
      )}

      <Footer
        isAdd={isAdd}
        isSubmitting={isSubmitting}
        handleSubmit={handleSubmit}
        history={history}
      />
    </Layout>
  );
};

const transformRefundAmount = val => {
  const num = parseFloat(val);
  return isNaN(num) ? 0 : Math.abs(num);
};

const AddModifyBookingForm = withFormik({
  mapPropsToValues: ({ tableBookingDataProps, tableSettingProps }) => {
    const refundsDetails =
      tableBookingDataProps?.payment?.refunds_details &&
      Array.isArray(tableBookingDataProps?.payment?.refunds_details)
        ? tableBookingDataProps?.payment?.refunds_details
        : [];

    const refundSummary = [];

    refundsDetails.forEach(ele => {
      const ra = transformRefundAmount(ele.refund_amount);

      const temp = {
        userId: ele.attempted_by,
        refundAmount: ra,
        refundType: ele.refund_type,
        refundedAt: ele.refunded_at,
        status: ele.status,
        refundReason: ele.refund_reason,
        note: ele.note,
      };

      refundSummary.push(temp);
    });

    const paymentCaptured =
      tableBookingDataProps?.payment?.payment_state === 'CAPTURED';

    return {
      paymentCaptured,
      contact_email:
        tableBookingDataProps &&
        !isNull(tableBookingDataProps?.contact?.contact_email)
          ? tableBookingDataProps.contact.contact_email
          : '',

      contact_phone:
        tableBookingDataProps &&
        !isNull(tableBookingDataProps?.contact?.contact_phone)
          ? tableBookingDataProps.contact.contact_phone
          : '',

      first_name:
        tableBookingDataProps &&
        !isNull(tableBookingDataProps?.contact?.first_name)
          ? tableBookingDataProps.contact.first_name
          : '',
      last_name:
        tableBookingDataProps &&
        !isNull(tableBookingDataProps?.contact?.last_name)
          ? tableBookingDataProps.contact.last_name
          : '',

      platform:
        tableBookingDataProps && !isNull(tableBookingDataProps?.platform)
          ? tableBookingDataProps.platform
          : 'ADMINUSER',

      guest_notes:
        tableBookingDataProps && !isNull(tableBookingDataProps.guest_notes)
          ? tableBookingDataProps.guest_notes
          : '',
      restaurant_notes:
        tableBookingDataProps && !isNull(tableBookingDataProps.restaurant_notes)
          ? tableBookingDataProps.restaurant_notes
          : '',
      tags:
        tableBookingDataProps && !isNull(tableBookingDataProps.tags)
          ? tableBookingDataProps.tags
          : [],

      booking_time:
        tableBookingDataProps && !isNull(tableBookingDataProps.booking_time)
          ? tableBookingDataProps.booking_time
          : '',
      guest_count:
        tableBookingDataProps && !isNull(tableBookingDataProps?.guest_count)
          ? tableBookingDataProps.guest_count
          : '',

      table_number:
        tableBookingDataProps && !isNull(tableBookingDataProps?.table_number)
          ? tableBookingDataProps.table_number
          : '',

      booking_date:
        tableBookingDataProps && !isNull(tableBookingDataProps?.booking_date)
          ? [
              tableBookingDataProps.booking_date.split('-')[1],
              tableBookingDataProps.booking_date.split('-')[0],
              tableBookingDataProps.booking_date.split('-')[2],
            ].join('-')
          : new Date(),

      booking_status:
        tableBookingDataProps && !isNull(tableBookingDataProps.booking_status)
          ? tableBookingDataProps.booking_status
          : 'CONFIRMED',

      guest_status:
        tableBookingDataProps && !isNull(tableBookingDataProps?.guest_status)
          ? tableBookingDataProps.guest_status
          : 'UPCOMING',
      emailNotif: tableSettingProps.isEmailNotificationCheckboxEnabled,
      smsNotif: tableSettingProps.isSMSNotificationCheckboxEnabled,
      refundSummary,
    };
  },

  validationSchema: yup.object().shape({
    contact_email: yup
      .string()
      .required('Email is required')
      .email('Invalid email format'),
    contact_phone: yup
      .number()
      .min(12, 'Please enter a valid mobile number')
      .required('Phone number is required'),
    // .max(13, 'Please enter a valid mobile number')
    booking_time: yup.string().required('Booking time is required'),
    guest_count: yup
      .number()
      .typeError('Please enter a valid number')
      .integer('Decimals are not allowed')
      .min(1, 'Guest Count must be at least 1')
      .max(999, 'Guest Count cannot exceed 999')
      .test(
        'maxDigits',
        'Guest Count must have at most 3 digits',
        value => value !== undefined && value.toString().length <= 3,
      )
      .required('Guest Count is required'),

    first_name: yup.string().required('First name is required'),
    last_name: yup.string().required('Last name is required'),
    guest_notes: yup
      .string()
      .max(144, 'Notes must be 144 characters or less')
      .test(
        'not-all-space',
        'Notes cannot be empty or contain only spaces',
        value => (value ? value.trim().length > 0 : true),
      ),
    restaurant_notes: yup
      .string()
      .max(144, 'Notes must be 144 characters or less')
      .test(
        'not-all-space',
        'Notes cannot be empty or contain only spaces',
        value => (value ? value.trim().length > 0 : true),
      ),
  }),
  validateOnBlur: false,
  validateOnChange: false,
  handleSubmit: async (values, { setSubmitting, props }) => {
    setSubmitting(true);

    const { createTableBooking, isAdd, placeId, history } = props;
    const {
      contact_email,
      contact_phone,
      first_name,
      last_name,
      booking_date,
      booking_status,
      booking_time,
      guest_count,
      guest_notes,
      guest_status,
      table_number,
      tags,
      restaurant_notes,
      platform,
    } = values;

    if (isAdd) {
      const input = {
        contact: {
          contact_email,
          contact_phone,
          first_name,
          last_name,
        },
        restaurant_notes,

        booking_date: new Date(booking_date)
          .toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          })
          .replaceAll('/', '-'),
        booking_status,
        booking_time,
        guest_count,
        guest_notes,
        guest_status,
        table_booking_id: uuidv4(),
        table_number,
        tags,
        place_id: placeId,
        service_type_setting_id:
          props.tableSettingProps.service_type_setting_id,
        app_type: platform,
        user_role: props.userRole,
      };
      const res = await createTableBooking(input);
      if (!res.isError) {
        // table_booking_id: tableBookingDetails.table_booking_id,
        // booking_status: 'RECEIVED',
        // payment: {
        //   payment_method: 'card',
        //   payment_method_id: payment.id,
        //   payment_method_type: 'CARD',
        // },
        // user_id: userId,

        // const { table_booking_id } = res.data;

        // props.updateTableBooking();
        swal('Successfully created table booking').then(() => {
          history.goBack();
        });
      } else {
        toast.error('Error while updating table booking');
      }
    } else {
      const { table_booking_id, user_id } = props.tableBookingDataProps;

      const input = {
        contact: {
          contact_email,
          contact_phone,
          first_name,
          last_name,
        },
        restaurant_notes,
        booking_date: new Date(booking_date)
          .toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          })
          .replaceAll('/', '-'),
        booking_time,
        guest_count,
        guest_notes,
        table_booking_id,
        table_number,
        tags,
        user_id: user_id || props.adminUserId,
        place_id: placeId,
        service_type_setting_id:
          props.tableSettingProps.service_type_setting_id,
        app_type: platform,
        user_role: props.userRole,
        booking_status: 'MODIFIED',
        is_sms_enabled: values.smsNotif,
        is_email_enabled: values.emailNotif,
      };

      if (
        props.tableBookingDataProps.booking_status !== values.booking_status
      ) {
        if (values.booking_status === 'CANCELLED') {
          swal({
            text: 'Would you like to cancel this table booking?',
            buttons: ['Cancel', 'OK'],
          }).then(async response => {
            if (response) {
              input.booking_status = booking_status;
              const res = await props.updateTableBooking(input);
              if (!res) {
                swal('Successfully updated table booking').then(() => {
                  history.goBack();
                });
              }
            } else {
              // pass
            }
          });
        } else {
          input.booking_status = booking_status;

          const res = await props.updateTableBooking(input);

          if (!res) {
            swal('Successfully updated table booking').then(() => {
              history.goBack();
            });
          }
        }
      } else {
        const res = await props.updateTableBooking(input);

        if (!res) {
          swal('Successfully updated table booking').then(() => {
            history.goBack();
          });
        }
      }
    }
    setSubmitting(false);
  },
  displayName: 'Form',
})(Form);

const useRefState = refValue => {
  const initialiseRef = React.useRef(true);
  const [refState, setRefState] = React.useState();

  if (initialiseRef.current && refValue) {
    setRefState(refValue);
    initialiseRef.current = false;
  }
  return [refState, setRefState];
};

const useUserRole = () => {
  const { user } = useStoreState(state => state.auth);
  const rolesArray = Array.isArray(user?.role) ? user.role : [];

  let userRole = null;

  const temp = new Map();

  rolesArray.forEach(rls => {
    if (rls === 'kravein_super_admin') {
      temp.set('kravein_super_admin', true);
    } else if (rls.startsWith('kravein_')) {
      temp.set('kravein_admin', true);
    } else if (rls.startsWith('partner_')) {
      temp.set('partner_admin', true);
    }
  });

  if (temp.get('kravein_super_admin')) {
    userRole = 'kravein_super_admin';
  } else if (temp.get('kravein_admin')) {
    userRole = 'kravein_admin';
  } else if (temp.get('partner_admin')) {
    userRole = 'partner_admin';
  }

  return userRole;
};

const AddModifyBooking = ({ match, history }) => {
  const [tableBookingId, ,] = useRefState(match.params.id);
  const [placeId, ,] = useRefState(match.params.placeId);
  const { userId: adminUserId } = useStoreState(state => state.auth);
  const [
    updatingTableBooking,
    updateTableBooking,
    reloadTableBookingData,
    updateTableBookingError,
  ] = useUpdateTableBooking();
  const [dataLoading, tableBookingData] = useTableBookingsDetails({
    adminUserId,
    tableBookingId,
    reloadTableBookingData,
  });
  const tableBookingDataProps = tableBookingData ?? null;
  const [_tableSettingProps] = useTableSetting({ placeId });
  const [tableSettingPropsPrivate] = useTableSettingPrivate({ placeId });

  const isEmailNotificationCheckboxEnabled = (() => {
    if (tableSettingPropsPrivate === null) {
      return false;
    }

    return true;
  })();

  const isSMSNotificationCheckboxEnabled = (() => {
    if (tableSettingPropsPrivate === null) {
      return false;
    }

    if (
      tableSettingPropsPrivate?.notification_setting
        ?.sms_user_confirm_booking ||
      tableSettingPropsPrivate?.notification_setting?.sms_user_cancel_booking ||
      tableSettingPropsPrivate?.notification_setting?.sms_user_modified_booking
    ) {
      return true;
    }

    return false;
  })();

  const tableSettingProps = {
    ..._tableSettingProps,
    ...tableSettingPropsPrivate,
    isEmailNotificationCheckboxEnabled,
    isSMSNotificationCheckboxEnabled,
  };

  const [, createTableBooking, ,] = useCreateTableBooking();

  const isAdd = tableBookingId === undefined;

  const userRole = useUserRole();

  if (dataLoading) {
    return (
      <Layout>
        <Wrapper>
          <Level>
            <Level.Item align="left">
              <div>
                <h1 className="mb-0 title is-size-4-touch is-size-3-desktop is-size-2-widescreen is-size-1-fullhd">
                  Manage Booking
                </h1>
                <span>
                  Manage your bookings and waitlists for a specific day
                </span>
              </div>
            </Level.Item>
            <Level.Item
              align="right"
              style={{ padding: 0, marginTop: 0, marginBottom: 0 }}
            >
              <Level.Item>
                <a onClick={() => history.goBack()} className="button is-grey">
                  <span className="has-text-weight-semibold">Cancel</span>
                </a>
              </Level.Item>
            </Level.Item>
          </Level>
        </Wrapper>
        loading...
      </Layout>
    );
  }
  return (
    <AddModifyBookingForm
      adminUserId={adminUserId}
      updateTableBookingError={updateTableBookingError}
      history={history}
      isAdd={isAdd}
      placeId={placeId}
      tableBookingId={tableBookingId}
      tableSettingProps={tableSettingProps}
      updatingTableBooking={updatingTableBooking}
      updateTableBooking={updateTableBooking}
      createTableBooking={createTableBooking}
      tableBookingDataProps={tableBookingDataProps}
      userRole={userRole}
    />
  );
};

export default AddModifyBooking;
